export class DataProcess {
    Cliente: any;
    Rut: any;
    NumeroOrden: any;
    TotalaPagar: any;
}